{
  "providers": [
    {
      "id": "xai",
      "label": "xAI",
      "models": [
        {
          "id": "grok-voice-think-fast-1.0",
          "label": "Grok Voice Fast"
        }
      ],
      "voices": [
        { "id": "eve", "label": "Eve" },
        { "id": "verse", "label": "Verse" }
      ],
      "defaultModel": "grok-voice-think-fast-1.0",
      "defaultVoice": "eve"
    },
    {
      "id": "openai",
      "label": "OpenAI",
      "models": [
        {
          "id": "gpt-realtime-2",
          "label": "GPT Realtime 2"
        },
        {
          "id": "gpt-realtime",
          "label": "GPT Realtime (legacy)"
        }
      ],
      "voices": [
        { "id": "marin", "label": "Marin" },
        { "id": "verse", "label": "Verse" },
        { "id": "cedar", "label": "Cedar" }
      ],
      "defaultModel": "gpt-realtime-2",
      "defaultVoice": "marin"
    }
  ]
}
